export const ENVIRONMENTAL_MODEL_SOURCE_ID = "environmental-model-predictions";
export const ENVIRONMENTAL_MODEL_LAYER = "environmental-model-predictions-circles";

export const PREDICTION_TYPE_LABELS = {
  flood: "Flood probability",
  landslide: "Landslide / slope instability",
  storm_severity: "Storm severity",
  infrastructure_disruption: "Infrastructure disruption",
};

export const MODEL_DISCLAIMER =
  "These are environmental model signals based on available data, not official emergency warnings.";

export const PREDICTION_TYPE_COLORS = {
  flood: "#2563eb",
  landslide: "#92400e",
  storm_severity: "#7c3aed",
  infrastructure_disruption: "#b45309",
};

export const MODEL_RISK_COLOR_EXPRESSION = [
  "match",
  ["get", "riskLevel"],
  "moderate",
  "#eab308",
  "elevated",
  "#f97316",
  "high",
  "#ef4444",
  "critical",
  "#7f1d1d",
  "#94a3b8",
];

export function formatPredictionTypeLabel(type) {
  return PREDICTION_TYPE_LABELS[type] || String(type || "Model signal").replace(/_/g, " ");
}

export function formatModelScore(value) {
  if (value == null || !Number.isFinite(Number(value))) {
    return "—";
  }

  return `${Math.round(Number(value))}`;
}
